export default "__VITE_ASSET__DFi2P76l__$_?component__"